<template>
  <div>
    <div v-if="src === null" class="embed loading">Loading embed data</div>
    <div v-else-if="src === false" class="embed loading">Failed to load embed data</div>
    <div v-else v-html="src" class="embed"></div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment-timezone'
import regExp from '@/common/regExp'

export default {
  name: 'Embed',
  props: [
    'locale',
    'value'
  ],
  computed: {
    siteinfo () {
      return this.$store.state.authentication
    },
    ln () {
      return this.$route.params.ln
    }
  },
  watch: {
    '$route' (to, from) {
      this.getIframeValue(this.value)
    }
  },
  created () {
    this.getIframeValue(this.value)
  },
  data () {
    return {
      src: null
    }
  },
  methods: {
    varFormatter (data) {
      let value = ''
      if (data && data.value) {
        value = data.value
        switch (data.type) {
          case 'currency':
            const code = this.currencyCode
            value = regExp.priceFormat(value, code)
            break
          case 'integer':
            value = parseInt(value)
            break
          case 'float':
            value = parseFloat(value)
            break
          case 'datetime':
            const datetime = DateTime.fromISO(value || moment().toISOString(), { zone: this.timezone })
            value = datetime.toFormat(this.dateTimeFormat)
            break
          default: // string
            break
        }
      }
      return value
    },
    async getIframeValue (value) {
      let vars = []
      let arr = []
      const authentication = this.siteinfo
      const pattern = /(?=\{\{)(.*?)(?=\}\})/g
      const split = value && value.split(pattern)
      const lang = this.ln
      function strToEl (str) {
        const template = document.createElement('template')
        template.innerHTML = str
        template.content.firstChild.setAttribute('loading', 'lazy')
        return template.content.firstChild.outerHTML
      }
      split.forEach(function (itemStr, index) {
        itemStr = itemStr.replaceAll(/{|}/g, '')
        /**
         * src에 파라미터 정보의 변수가 있는 경우
         * 파라미터에서 해당 정보를 가져와서 치환
         */
        if (itemStr.startsWith('params-')) {
          const paramsKey = itemStr.replace('params-', '')
          const paramsValue = authentication[paramsKey]
          arr.push(paramsValue)
        } else if (itemStr.startsWith('vars-')) {
          // guest info api 호출용
          arr.push('')
          vars.push({
            index: index,
            key: itemStr.replace('vars-', '')
          })
        } else if (itemStr === 'lang') {
          arr.push(lang)
        } else {
          arr.push(itemStr)
        }
      })
      /**
       * src에 {{guest-info-var}}가 있는 경우 (게스트정보)
       * guest info 호출하여 치환
       */
      if (vars.length) {
        this.$store.commit('loading', true)
        const varsKey = vars.map(x => x.key)
        const varRes = await this.$store.dispatch('authentication/getVariable', varsKey).then((res) => {
          return res
        })
        if (varRes) {
          const varValue = Object.keys(varRes).map(x => {
            return {
              key: x,
              value: varRes[x].value.value || '',
              type: varRes[x].value.type || 'string'
            }
          })
          if (varValue.length > 0) {
            for (let i = 0; i < vars.length; i++) {
              const item = vars[i]
              arr[item.index] = this.varFormatter({ type: varRes[item.key].value.type, value: varRes[item.key].value.value })
            }
          }
        }
        this.$store.commit('loading', false)
      }

      this.src = strToEl(arr.join(''))
    }
  }
}
</script>

<style lang="scss" scoped>
.embed {
  &.loading {
    padding: 60px 15px;
    font-size: 14px;
    color: $color-lgrey;
    text-align: center;
    background-color: rgba($color-lgrey2, 0.5);
  }
}
</style>
